<div class="info--wrapper"  style="max-width: 200px;">
    <nx-icon nxFormfieldAppendix name="info-circle-o"
        nxPopoverTrigger="hover">
  </nx-icon>
</div>